import React from "react";
import "../TncPrivacyPolicy/TNC.css";
import { Container } from "react-bootstrap";
import {
  FaFileContract,
  FaDownload,
  FaMusic,
  FaCopyright,
  FaUserShield,
  FaBan,
  FaMoneyBillWave,
  FaGavel,
  FaShieldAlt,
  FaSyncAlt,
  FaGlobe,
  FaExclamationTriangle,
  FaBalanceScale,
  FaHandshake,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";

const LabelAgreement = () => {
  return (
    <div className="tnc-container">
      <Container>
        <div className="tnc-wrapper">
          {/* Header Section */}
          <div className="tnc-header">
            <h1 className="main-title">
              <span className="text-yellow">LABEL DISTRIBUTION</span>{" "}
              <span className="text-pink">AGREEMENT</span>
            </h1>
            
            <p className="intro-text">
              This Label Distribution Agreement ("Agreement") is entered into by and between Final Take Production Pvt. Ltd., operating under the brand name FT Tunes ("FT Tunes", "Distributor"), and any record label, music company, rights holder, or authorized representative ("Label") using FT Tunes' distribution services.
            </p>
            <p className="intro-text mt-3">
              By submitting content to FT Tunes for distribution, the Label acknowledges that it has read, understood, and agreed to the terms of this Agreement.
            </p>

            <div className="mt-4 flex justify-content-center">
              <a
                href="/Images/label-agreement.pdf"
                download="label-agreement.pdf"
                className="btn btn-primary"
                style={{
                  background: "linear-gradient(45deg, #d70d57, #ff4081)",
                  border: "none",
                  padding: "10px 25px",
                  borderRadius: "25px",
                  color: "#fff",
                  fontWeight: "bold",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px"
                }}
              >
                <FaDownload /> Download PDF
              </a>
            </div>
          </div>

          {/* Section 1 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number purple-gradient">1</span>
              <FaFileContract className="section-icon-inline mr-2 text-purple" />{" "}
              APPOINTMENT
            </h2>
            <p className="section-text mb-3">
              The Label hereby appoints FT Tunes as its non-exclusive digital distribution partner for the distribution, administration, monetization, and management of its music content through digital music platforms worldwide.
            </p>
            <p className="section-text">
              FT Tunes accepts such appointment subject to the terms of this Agreement.
            </p>
          </div>

          {/* Section 2 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number orange-gradient">2</span>
              <FaHandshake className="section-icon-inline mr-2 text-orange" />{" "}
              GRANT OF RIGHTS
            </h2>
            <p className="section-text mb-2">The Label grants FT Tunes a non-exclusive, worldwide license to:</p>
            <ul className="custom-list mb-3">
              <li>Distribute and make available the Label's content on digital music services and social media platforms.</li>
              <li>Deliver content to streaming, download, and content monetization platforms.</li>
              <li>Collect and account for revenues generated from the distributed content.</li>
              <li>Manage metadata, content updates, and takedown requests.</li>
              <li>Create promotional clips, previews, and marketing materials solely for the purpose of promoting the content.</li>
            </ul>
            <p className="section-text">
              This Agreement does not transfer ownership of any copyrights, trademarks, master recordings, or intellectual property rights to FT Tunes.
            </p>
          </div>

          {/* Section 3 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number pink-gradient">3</span>
              <FaCopyright className="section-icon-inline mr-2 text-pink" />{" "}
              OWNERSHIP
            </h2>
            <p className="section-text mb-2">The Label shall retain full ownership of all:</p>
            <ul className="custom-list mb-3">
              <li>Master recordings;</li>
              <li>Sound recordings;</li>
              <li>Copyrights;</li>
              <li>Trademarks;</li>
              <li>Artwork;</li>
              <li>Metadata;</li>
              <li>Associated intellectual property rights.</li>
            </ul>
            <p className="section-text">
              Nothing contained in this Agreement shall be construed as an assignment of ownership to FT Tunes or Final Take Production Pvt. Ltd.
            </p>
          </div>

          {/* Section 4 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number blue-gradient">4</span>
              <FaUserShield className="section-icon-inline mr-2 text-blue" />{" "}
              LABEL WARRANTIES
            </h2>
            <p className="section-text mb-2">The Label represents and warrants that:</p>
            <ol className="custom-list mb-3" style={{ listStyleType: "decimal", paddingLeft: "1.5rem" }}>
              <li>It owns or controls all rights necessary to distribute the content.</li>
              <li>All artists, performers, composers, producers, and contributors have been properly authorized.</li>
              <li>Any third-party samples, recordings, artwork, or materials have been legally cleared.</li>
              <li>The content does not infringe upon the rights of any third party.</li>
              <li>The content complies with applicable laws, regulations, and platform policies.</li>
              <li>All metadata, ownership information, and credits supplied to FT Tunes are accurate and complete.</li>
            </ol>
            <p className="section-text">
              The Label shall be solely responsible for securing and maintaining all necessary licenses, permissions, and clearances.
            </p>
          </div>

          {/* Section 5 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number red-gradient">5</span>
              <FaMusic className="section-icon-inline mr-2 text-red" />{" "}
              DISTRIBUTION SERVICES
            </h2>
            <p className="section-text mb-2">
              FT Tunes shall use commercially reasonable efforts to distribute content to digital service providers including, but not limited to:
            </p>
            <ul className="custom-list mb-3">
              <li>Spotify</li>
              <li>Apple Music</li>
              <li>YouTube Music</li>
              <li>Amazon Music</li>
              <li>TikTok</li>
              <li>Instagram</li>
              <li>Facebook</li>
              <li>Deezer</li>
              <li>TIDAL</li>
              <li>JioSaavn</li>
              <li>Gaana</li>
              <li>Wynk</li>
              <li>Other current and future partner platforms</li>
            </ul>
            <p className="section-text mb-3">
              FT Tunes does not guarantee platform acceptance, playlist placement, promotion, chart performance, revenue generation, or continued availability of content.
            </p>
            <p className="section-text">
              All platform decisions remain solely under the control of the respective digital service providers.
            </p>
          </div>

          {/* Section 6 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number green-gradient">6</span>
              <FaMoneyBillWave className="section-icon-inline mr-2 text-green" />{" "}
              REVENUE SHARE AND PAYMENTS
            </h2>
            <p className="section-text mb-2">Revenue generated from the Label's content shall be shared as follows:</p>
            <ul className="custom-list mb-3">
              <li>80% (Eighty Percent) of Net Revenue shall be payable to the Label.</li>
              <li>20% (Twenty Percent) of Net Revenue shall be retained by FT Tunes as its distribution and administration fee.</li>
            </ul>
            <p className="section-text mb-3">
              "Net Revenue" means revenue actually received by FT Tunes from digital service providers and authorized monetization sources after deduction of applicable taxes, banking charges, payment processing fees, chargebacks, refunds, withholding taxes, and mandatory third-party deductions.
            </p>
            <p className="section-text mb-3">
              Royalty payments shall be based solely on reports and payments received from digital service providers.
            </p>
            <p className="section-text mb-2">FT Tunes reserves the right to withhold payments where:</p>
            <ul className="custom-list mb-3">
              <li>Ownership disputes exist;</li>
              <li>Copyright claims are pending;</li>
              <li>Fraudulent streaming activity is suspected;</li>
              <li>DSP penalties, reversals, or deductions apply;</li>
              <li>Additional verification is required.</li>
            </ul>
            <p className="section-text mb-3">
              No royalties shall become payable until corresponding funds have been received by FT Tunes.
            </p>
            <p className="section-text">
              The Label shall be solely responsible for compensating its artists, producers, composers, licensors, and other rights holders.
            </p>
          </div>

          {/* Section 7 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number orange-gradient">7</span>
              <FaBan className="section-icon-inline mr-2 text-orange" />{" "}
              CONTENT REMOVAL AND TAKEDOWNS
            </h2>
            <p className="section-text mb-3">
              The Label may request removal of content by submitting written notice to FT Tunes.
            </p>
            <p className="section-text mb-2">FT Tunes may immediately suspend, remove, or block content if:</p>
            <ul className="custom-list mb-3 red-bullets">
              <li>Copyright claims are received;</li>
              <li>Fraudulent activity is detected;</li>
              <li>Platform policies are violated;</li>
              <li>Ownership disputes arise;</li>
              <li>Continued distribution may expose FT Tunes to legal, financial, or reputational risk.</li>
            </ul>
            <p className="section-text">
              Content removal timelines are subject to the policies and processing times of the relevant digital service providers.
            </p>
          </div>

          {/* Section 8 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number pink-gradient">8</span>
              <FaGavel className="section-icon-inline mr-2 text-pink" />{" "}
              COPYRIGHT CLAIMS
            </h2>
            <p className="section-text mb-3">
              The Label shall be solely responsible for resolving all copyright, ownership, royalty, neighboring rights, trademark, or contractual disputes relating to its content.
            </p>
            <p className="section-text">
              FT Tunes shall have no obligation to participate in or finance any legal proceeding relating to such disputes.
            </p>
          </div>

          {/* Section 9 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number purple-gradient">9</span>
              <FaShieldAlt className="section-icon-inline mr-2 text-purple" />{" "}
              INDEMNIFICATION
            </h2>
            <p className="section-text mb-2">
              The Label agrees to indemnify, defend, and hold harmless FT Tunes, Final Take Production Pvt. Ltd., its directors, officers, employees, contractors, affiliates, partners, successors, and assigns from any claims, damages, liabilities, penalties, losses, costs, expenses, or legal fees arising from:
            </p>
            <ul className="custom-list mb-0">
              <li>Breach of this Agreement;</li>
              <li>Copyright infringement claims;</li>
              <li>Ownership disputes;</li>
              <li>Royalty disputes;</li>
              <li>Violations of law;</li>
              <li>Misrepresentation of rights or authority.</li>
            </ul>
          </div>

          {/* Section 10 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number red-gradient">10</span>
              <FaBan className="section-icon-inline mr-2 text-red" />{" "}
              TERM AND TERMINATION
            </h2>
            <p className="section-text mb-3">This Agreement shall remain in effect until terminated by either party.</p>
            <p className="section-text mb-3">Either party may terminate this Agreement by providing thirty (30) days written notice.</p>
            <p className="section-text mb-2">FT Tunes may immediately terminate this Agreement or remove content if:</p>
            <ul className="custom-list red-bullets mb-3">
              <li>The Label breaches any material provision of this Agreement;</li>
              <li>Fraudulent activity is detected;</li>
              <li>Repeated copyright violations occur;</li>
              <li>Continued business relations create legal or reputational risk.</li>
            </ul>
            <p className="section-text">
              Termination shall not affect accrued rights or payment obligations existing prior to termination.
            </p>
          </div>

          {/* Section 11 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number blue-gradient">11</span>
              <FaExclamationTriangle className="section-icon-inline mr-2 text-blue" />{" "}
              LIMITATION OF LIABILITY
            </h2>
            <p className="section-text mb-2">To the fullest extent permitted by law, FT Tunes and Final Take Production Pvt. Ltd. shall not be liable for:</p>
            <ul className="custom-list mb-3">
              <li>Loss of profits;</li>
              <li>Loss of revenue;</li>
              <li>Loss of business opportunities;</li>
              <li>Platform removals;</li>
              <li>Delayed releases;</li>
              <li>Technical failures;</li>
              <li>Service interruptions;</li>
              <li>Indirect, incidental, consequential, special, or punitive damages.</li>
            </ul>
            <p className="section-text">
              The maximum liability of FT Tunes under this Agreement shall not exceed the amount of fees retained by FT Tunes during the twelve (12) months preceding the claim.
            </p>
          </div>

          {/* Grid for 12 & 13 */}
          <div className="cards-grid-2">
            {/* Section 12 */}
            <div className="policy-section card-gradient-border d-flex-col">
              <h2 className="section-title">
                <span className="section-number orange-gradient">12</span>
                <FaShieldAlt className="section-icon-inline mr-2 text-orange" />{" "}
                CONFIDENTIALITY
              </h2>
              <p className="section-text mb-3">
                Both parties agree to keep confidential all non-public business information, royalty reports, financial data, account information, and proprietary business information exchanged during the course of the relationship.
              </p>
              <p className="section-text">
                This obligation shall survive termination of this Agreement.
              </p>
            </div>

            {/* Section 13 */}
            <div className="policy-section card-gradient-border d-flex-col">
              <h2 className="section-title">
                <span className="section-number pink-gradient">13</span>
                <FaHandshake className="section-icon-inline mr-2 text-pink" />{" "}
                INDEPENDENT CONTRACTOR RELATIONSHIP
              </h2>
              <p className="section-text mb-3">
                Nothing in this Agreement shall create a partnership, joint venture, employment relationship, agency relationship, or fiduciary relationship between the parties.
              </p>
              <p className="section-text">
                The parties shall remain independent contractors.
              </p>
            </div>
          </div>

          {/* Grid for 14 & 15 */}
          <div className="cards-grid-2">
            {/* Section 14 */}
            <div className="policy-section card-gradient-border d-flex-col">
              <h2 className="section-title">
                <span className="section-number green-gradient">14</span>
                <FaBalanceScale className="section-icon-inline mr-2 text-green" />{" "}
                GOVERNING LAW AND JURISDICTION
              </h2>
              <p className="section-text mb-3">
                This Agreement shall be governed by and construed in accordance with the laws of India.
              </p>
              <p className="section-text">
                Any dispute arising out of or relating to this Agreement shall be subject to the exclusive jurisdiction of the courts located in Kolkata, West Bengal, India.
              </p>
            </div>

            {/* Section 15 */}
            <div className="policy-section card-gradient-border d-flex-col">
              <h2 className="section-title">
                <span className="section-number purple-gradient">15</span>
                <FaSyncAlt className="section-icon-inline mr-2 text-purple" />{" "}
                ENTIRE AGREEMENT
              </h2>
              <p className="section-text mb-3">
                This Agreement constitutes the complete and exclusive agreement between the parties concerning the subject matter herein and supersedes all prior negotiations, communications, and understandings.
              </p>
              <p className="section-text">
                FT Tunes reserves the right to update this Agreement from time to time. Continued use of the services following publication of an updated Agreement shall constitute acceptance of the revised terms.
              </p>
            </div>
          </div>

          {/* Acceptance Section */}
          <div className="policy-section card-gradient-border mt-4">
            <h2 className="section-title text-center mb-4">
              <FaHandshake className="section-icon-inline mr-2 text-yellow" />{" "}
              ACCEPTANCE
            </h2>
            <p className="section-text text-center mb-4">
              By submitting content for distribution through FT Tunes, the Label confirms that it has read, understood, and agreed to be bound by this Agreement.
            </p>

            <div className="row mt-4">
              <div className="col-md-6 mb-4">
                <h4 className="mb-3 text-pink">FOR THE LABEL</h4>
                <div className="mb-2"><strong>Label Name:</strong> ______________________________________</div>
                <div className="mb-2"><strong>Authorized Representative:</strong> __________________________</div>
                <div className="mb-2"><strong>Designation:</strong> ________________</div>
                <div className="mb-2"><strong>Email:</strong> ____________________________________________</div>
                <div className="mb-2"><strong>Address:</strong> __________________________________________</div>
                <div className="mb-2"><strong>Signature:</strong> ___________________</div>
                <div className="mb-2"><strong>Date:</strong> _________________________</div>
              </div>
              <div className="col-md-6 mb-4">
                <h4 className="mb-3 text-yellow">FOR FINAL TAKE PRODUCTION PVT LTD</h4>
                <div className="mb-2"><strong>Final Take Production Pvt. Ltd.</strong></div>
                <div className="mb-2"><strong>Authorized Representative:</strong> __________________________</div>
                <div className="mb-2"><strong>Designation:</strong> __________________________</div>
                <div className="mb-2"><strong>Signature:</strong> ___________________________</div>
                <div className="mb-2"><strong>Date:</strong> _____________________________________________</div>
              </div>
            </div>
            
            <div className="mt-4 pt-3" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}>
              <h5 className="text-center text-blue mb-2">ELECTRONIC CONSENT</h5>
              <p className="section-text text-center" style={{ fontSize: "0.9rem" }}>
                The parties agree that electronic signatures, digital approvals, online acceptance, scanned signatures, and electronic records shall have the same legal effect as original handwritten signatures and shall be enforceable to the fullest extent permitted by applicable law.
              </p>
            </div>
          </div>

        </div>
      </Container>
    </div>
  );
};

export default LabelAgreement;
